module.exports = __webpack_public_path__ + "im.3e276e7d.svg";